// extracted by mini-css-extract-plugin
export default {"header":"contentComp_header__L3BXO","container":"contentComp_container__qMfl+"};